(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-promo-badge"] && !Shopify.designMode) return;
  try {
    
  class FloatingPromoBadge {
    constructor(element) {
      this.element = element;
      this.sectionId = element.dataset.sectionId;
      this.dismissMode = element.dataset.dismissMode;
      this.delay = Number(element.dataset.delay || 0);
      this.attentionDuration = Number(element.dataset.attentionDuration || 0);
      this.closeButton = element.querySelector('[data-floating-promo-close]');
      this.storageKey = `floating-promo-badge-${this.sectionId}`;

      if (this.isDismissed()) {
        this.element.classList.add('is-hidden');
        return;
      }

      window.setTimeout(() => {
        this.element.classList.add('is-visible');
        this.playAttention();
      }, this.delay);

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.dismiss());
      }
    }

    playAttention() {
      if (this.attentionDuration <= 0 || this.element.classList.contains('floating-promo-badge--attention-none')) {
        return;
      }

      window.setTimeout(() => {
        this.element.classList.add('is-attention');
      }, 520);

      window.setTimeout(() => {
        this.element.classList.remove('is-attention');
      }, this.attentionDuration + 520);
    }

    isDismissed() {
      if (this.dismissMode === 'never') {
        return false;
      }

      if (this.dismissMode === 'session') {
        return window.sessionStorage.getItem(this.storageKey) === 'dismissed';
      }

      const value = window.localStorage.getItem(this.storageKey);

      if (!value) {
        return false;
      }

      const expiresAt = Number(value);
      return expiresAt > Date.now();
    }

    dismiss() {
      if (this.dismissMode === 'session') {
        window.sessionStorage.setItem(this.storageKey, 'dismissed');
      }

      if (this.dismissMode === 'one_day') {
        window.localStorage.setItem(this.storageKey, String(Date.now() + 86400000));
      }

      if (this.dismissMode === 'seven_days') {
        window.localStorage.setItem(this.storageKey, String(Date.now() + 604800000));
      }

      this.element.classList.remove('is-visible');
      window.setTimeout(() => {
        this.element.classList.add('is-hidden');
      }, 260);
    }
  }

  const initFloatingPromoBadges = () => {
    document.querySelectorAll('[data-floating-promo-badge]').forEach((element) => {
      if (!element.dataset.initialized) {
        element.dataset.initialized = 'true';
        new FloatingPromoBadge(element);
      }
    });
  };

  initFloatingPromoBadges();

  document.addEventListener('shopify:section:load', initFloatingPromoBadges);

  } catch(e) { console.error(e); }
})();
})();
